import './common/main.js';

console.log('In myuni.js');

// code specific to myuni

console.log('myuni.js ends');
